import React from 'react';
import PropTypes from 'prop-types';
import FormInput from '../../commonComponents/forms/FormInput';
import translate from '../../commonComponents/translate';
import Form from '../../commonComponents/forms/Form';
import StepList from './StepList';

const displayRequired = label => `${label}*`;

function Step1({
  t,
  form,
  onFormChange,
  onSubmitForm,
  isLoading,
  step,
  countries,
}) {
  const {
    firstName,
    lastName,
    email,
    phone,
    organizationName,
    password,
    confirmPassword,
  } = form;
  const validationRules = {
    firstName: { required: true },
    lastName: { required: true },
    email: { required: true, email: true },
    phone: { required: true },
    organizationName: { required: true },
    password: { required: true, minlength: 6 },
    confirmPassword: {
      required: true,
      equalTo: '#password',
    },
  };

  const inputProps = { autoComplete: 'off' };
  const groupProps = { className: 'step-form-display' };

  return (
    <>
      <h2 className="trial-header">{t('trial.create.account')}</h2>
      <h4 className="trial-subheader">{t('trial.create.details')}</h4>
      <StepList activeStep={step} ignore />

      <Form
        id="trial1Form"
        className="m-login__form m-form"
        validationRules={validationRules}
        submitMethod={onSubmitForm}
      >
        {submitHandler => (
          <>
            <div className="step-form-username">
              <FormInput
                id="firstName"
                placeholder={t('profile_firstName')}
                label={displayRequired(t('profile_firstName'))}
                name="firstName"
                value={firstName}
                onChange={value => onFormChange('firstName', value)}
                containerClassName="step-form-container"
                inputProps={inputProps}
                groupProps={groupProps}
              />
              <FormInput
                id="lastName"
                placeholder={t('profile_lastName')}
                label={displayRequired(t('profile_lastName'))}
                name="lastName"
                value={lastName}
                onChange={value => onFormChange('lastName', value)}
                containerClassName="step-form-container"
                inputProps={inputProps}
                groupProps={groupProps}
              />
            </div>
            <FormInput
              id="email"
              placeholder={t('profile_email')}
              label={displayRequired(t('profile_email'))}
              name="email"
              value={email}
              onChange={value => onFormChange('email', value)}
              containerClassName="step-form-container"
              inputProps={{ autoComplete: 'new-email' }}
              groupProps={groupProps}
            />
            <FormInput
              id="phone"
              type="phone"
              placeholder={t('billing_phone')}
              label={displayRequired(t('billing_phone'))}
              name="phone"
              value={phone}
              onChange={value => onFormChange('phone', value)}
              onCountrySelection={value => onFormChange('countryPhone', value)}
              containerClassName="step-form-container"
              inputProps={inputProps}
              groupProps={groupProps}
              countries={countries}
            />
            <FormInput
              id="organizationName"
              placeholder={t('trial_info_organizationName')}
              label={displayRequired(t('trial_info_organizationName'))}
              name="organizationName"
              value={organizationName}
              onChange={value => onFormChange('organizationName', value)}
              containerClassName="step-form-container"
              inputProps={inputProps}
              groupProps={groupProps}
            />
            <FormInput
              type="password"
              id="password"
              placeholder={t('profile_password')}
              label={displayRequired(t('profile_password'))}
              name="password"
              value={password}
              onChange={value => onFormChange('password', value)}
              containerClassName="step-form-container"
              inputProps={{ autoComplete: 'new-password' }}
              groupProps={groupProps}
            />
            <FormInput
              type="password"
              id="confirmPassword"
              placeholder={t('profile_confirmPassword')}
              label={displayRequired(t('profile_confirmPassword'))}
              name="confirmPassword"
              value={confirmPassword}
              onChange={value => onFormChange('confirmPassword', value)}
              containerClassName="step-form-container"
              inputProps={inputProps}
              groupProps={groupProps}
            />
            <div className="button-container">
              <button
                type="submit"
                onClick={submitHandler}
                className="button-trial"
                disabled={isLoading}
              >
                <span className="button-text">{t('next')}</span>
                {isLoading && <i className="fa fa-spinner spinner" />}
              </button>
            </div>
          </>
        )}
      </Form>
    </>
  );
}

Step1.propTypes = {
  t: PropTypes.func.isRequired,
  form: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    organizationName: PropTypes.string,
    password: PropTypes.string,
    confirmPassword: PropTypes.string,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      flagEmoji: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default translate(Step1);
